import { Link } from 'react-router-dom';
import { NAV_MENUS, SINGLE_LINKS } from './navData';

export default function MobileMenu() {
  return (
    <div className="lg:hidden bg-mcx-white border-t border-mcx-mist overflow-y-auto max-h-screen" data-testid="mobile-menu">
      <div className="max-w-content mx-auto px-6 py-6 space-y-7">
        {Object.entries(NAV_MENUS).map(([key, { label, items }]) => (
          <div key={key}>
            <p className="text-xs font-semibold uppercase tracking-widest text-mcx-signal mb-3">{label}</p>
            <div className="space-y-0.5">
              {items.map(({ label: iLabel, href }) => (
                <Link
                  key={href}
                  to={href}
                  className="block px-3 py-2.5 rounded-md text-sm font-medium text-mcx-ink hover:bg-mcx-paper transition-colors"
                >
                  {iLabel}
                </Link>
              ))}
            </div>
          </div>
        ))}
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-mcx-signal mb-3">More</p>
          <div className="space-y-0.5">
            {SINGLE_LINKS.map(({ label, href }) => (
              <Link
                key={href}
                to={href}
                className="block px-3 py-2.5 rounded-md text-sm font-medium text-mcx-ink hover:bg-mcx-paper transition-colors"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <Link
          to="/book-a-call"
          className="flex items-center justify-center gap-2 text-white px-6 py-3 rounded-md font-medium"
          style={{ backgroundColor: '#0EA5E9' }}
          data-testid="mobile-book-call"
        >
          Book a 30-minute scoping call &rarr;
        </Link>
      </div>
    </div>
  );
}
